export default{
    commonConfiguration:{
        Notification:{
        },
        Message:{
            error:'服务端异常'
        },
        Alert:{

        },
        Button:{
            confirm:'确定',
            back:'返回',
            cancel:'取消',
            login:'登录',
            loggedIn:'已登录',
            logout:'退出',
            mallCenter:'数字交易中心',
            regist:'注册',
            More:'更多',
            SeeMore:'查看更多',
            button1:'搜索',
            button3:'账号管理',
            button4:'我是卖家',
            button5:'买家工作台',
            button6:'我的订单',
            button7:'账号信息',
            button8:'账号安全',
            button9:'企业认证',
            button10:'我的进货单',
            button11:'我的',
            button12:'购物车',
            button13:'客服',
            button14:'顶部'
        },
        Footer:{
            Landline:'联系电话',
            LandlineNumber:'0536-7267526',
            Email:'联系邮箱',
            EmailAddress:'nfstzx@nfstzx.com',
            ContactAddress:'联系地址',
            ContactAddressContent:'山东省潍坊市国家农业开放发展综合试验区总部基地A座',
            FriendLinks:'友情链接',
            AboutThePlatform: '关于平台',
            AboutUs: '关于我们',
            TermsOfService: '服务条款',
            PrivacyPolicy: '隐私政策',
            ServiceAgreement: '服务协议',
            HelpCenter: '帮助中心',
            DownloadUserManual: '用户手册下载',
            FeedbackAndSuggestions: '意见与反馈',
            PublicConsultation: '意见征集',
            Copyright: '潍坊农业开放发展集团有限公司'
        },
        Href:{
            href1:'中国国际减贫中心',
            href2:'农业农村部国际交流服务中心',
            href3:'农业农村部国际合作司',
            href4:'农业农村部农业贸易促进中心',
            href5:'农业农村部对外经济合作中心',
        },
        Placeholder:{
            placeholder1:'请输入你想要的产品信息',
        },
        Validate:{

        },
        Description:{
            hello:'您好，欢迎来到',
            Loggedin:'已登录'
        },
        Checkbox:{
        },
        Table:{
        }
    }
    
}